import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common';
import {
	ProgrammeUserWithPermissionRolesRes,
	PermissionRolesDto,
} from '@dealstack/shared/lib/generated';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { ServiceRequestOptions } from '@dealstack/frontend/shared/other/react/ApiWrapper/types';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn';
import { ResourceType } from '@dealstack/shared/lib/common/fineGrainedAuthorization/permissions';

export const setPermissionsForResourceType = async (
	args: {
		body: PermissionRolesDto;
		params: { resourceType: ResourceType; resourceId: string };
	},
	options?: ServiceRequestOptions
) => {
	const response = await makeRequest<ApiV1.Response<ProgrammeUserWithPermissionRolesRes[]>>(
		{
			endpoint: formatUnicorn(
				API_PATHS.PERMISSIONS_RESOURCETYPE_RESOURCEID_PERMISSIONS_SET_POST,
				{
					resourceType: args.params.resourceType,
					resourceId: args.params.resourceId,
				}
			),
			method: HTTP_METHOD.POST,
			body: JSON.stringify(args.body),
		},
		{ ...options }
	);
	return response;
};
